var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"redirect_dispatcher"},[_c('p',[_vm._v("Redirigiendo…")])])
}]

export { render, staticRenderFns }